import './post_single.scss';

console.log('post_single')